import React from "react";
import { Modal, message, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useDeleteConfigurationMutation } from "../../../services/ApiSlice.ts";
import "./DeleteModal.css"

interface DeleteModalProps {
  configurationId: string;
  visible: boolean;
  onClose: () => void;
  onDeleteSuccess?: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  configurationId,
  visible,
  onClose,
  onDeleteSuccess,
}) => {
  const [deleteConfiguration, { isLoading }] = useDeleteConfigurationMutation();
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await deleteConfiguration(configurationId).unwrap();
      message.success("Configuration deleted.");
      navigate("/");
      onDeleteSuccess?.();
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
      message.error("Delete failed.");
    }
  };

  return (
    <Modal
      className="delete-modal"
      title="Delete Configuration"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="delete" type="primary"  loading = {isLoading} onClick={handleDelete}>Delete</Button>,
        <Button key="cancel" disabled = {isLoading} onClick={onClose} >Cancel</Button>,
      ]}

      maskClosable={false}
    >
    <p className="delete-confirm-text"> 
        Are you sure you want to delete this configuration? 
    </p>
    </Modal>
  );
};

export default DeleteModal;
